/**
 * Copyright (c) 2017-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
import { Editor } from './components/Editor';
export { Editor };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@tinymce/tinymce-react/lib/es2015/main/ts/index.js
// module id = 786
// module chunks = 0